// extracted by mini-css-extract-plugin
export default {"chatContainer":"ChatContainer_chatContainer__cMBZa","leftArea":"ChatContainer_leftArea__VNGv6","rightArea":"ChatContainer_rightArea__Qz2sO"};